import IndexPage from './js/home.js';

window.IndexPage = IndexPage;